"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const react_1 = __importDefault(require("react"));
const MetaModules_context_1 = require("./MetaModules.context");
const MetaModules_utils_1 = require("./MetaModules.utils");
function appWithMetaModules(WrappedAppComponent) {
    function AppWithMetaModules(props) {
        return (react_1.default.createElement(MetaModules_context_1.MetaModulesContext.Provider, { value: (0, MetaModules_utils_1.getMetaModulesPageProp)(props.pageProps) },
            react_1.default.createElement(WrappedAppComponent, Object.assign({}, props))));
    }
    return (0, hoist_non_react_statics_1.default)(AppWithMetaModules, WrappedAppComponent);
}
exports.default = appWithMetaModules;
//# sourceMappingURL=appWithMetaModules.js.map